export const CONTRACT_STATUSES = ['новый', 'в работе', 'приостановлен', 'завершен', 'отменен']

export const CONTRACT_BUDGET_STATUSES = ['новый', 'в согласовании', 'согласован']

const ACTIONS = {
  prepayment: { key: 'prepayment', label: 'Отметить предоплату', type: 'action', icon: 'file', variant: 'secondary' },
  sendBudgetApproval: { key: 'approve_budget', label: 'Отправить бюджет на согласование', type: 'navigate', icon: 'file-check', variant: 'secondary' },
  repeatBudgetApproval: { key: 'resend_budget_approval', label: 'Повторить согласование бюджета', type: 'navigate', icon: 'refresh', variant: 'outline' },
  startWork: { key: 'start_work', label: 'Перевести в работу', targetStatus: 'в работе', icon: 'play', variant: 'primary', tone: 'success' },
  pause: { key: 'suspend', label: 'Приостановить', targetStatus: 'приостановлен', icon: 'pause', variant: 'secondary', tone: 'warning' },
  resume: { key: 'resume', label: 'Возобновить в работу', targetStatus: 'в работе', icon: 'play', variant: 'primary', tone: 'success' },
  complete: { key: 'complete', label: 'Завершить', targetStatus: 'завершен', icon: 'check', variant: 'primary', tone: 'success' },
  cancel: { key: 'cancel', label: 'Отменить договор', targetStatus: 'отменен', icon: 'close', variant: 'danger' },
  viewApprovals: { key: 'view_approvals', label: 'Посмотреть согласования', type: 'navigate', icon: 'view', variant: 'outline' }
}

function normalizeStatus(value) {
  return String(value || '').toLowerCase().trim()
}

function getBudgetApprovalAction(budgetStatus) {
  const normalizedBudgetStatus = normalizeStatus(budgetStatus)
  if (normalizedBudgetStatus === 'в согласовании') return ACTIONS.viewApprovals
  if (normalizedBudgetStatus === 'согласован') return ACTIONS.repeatBudgetApproval
  return ACTIONS.sendBudgetApproval
}

export function getStatusActions(status, budgetStatus = 'новый') {
  const normalized = normalizeStatus(status || 'новый')
  const budgetAction = getBudgetApprovalAction(budgetStatus)

  if (normalized === 'новый') {
    return [ACTIONS.prepayment, budgetAction, ACTIONS.startWork, ACTIONS.cancel]
  }

  if (normalized === 'в работе') {
    return [ACTIONS.prepayment, budgetAction, ACTIONS.pause, ACTIONS.complete, ACTIONS.cancel]
  }

  if (normalized === 'приостановлен') {
    return [ACTIONS.resume, ACTIONS.cancel]
  }

  return []
}
